import React from "react";
import * as styles from "../time/time.module.scss";

/**
 * @type {Object} 「UI:atoms - タイム 投稿日・最終更新日 記事用 コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {Date} publishDate 投稿日を受け取るための引数です。
 * @param {String} publishDateJP 指定した日付のフォーマットに変換した投稿日を受け取るための引数です。
 * @param {Date} updatedAt 最終更新日を受け取るための引数です。
 * @param {String} updatedAtJP 指定した日付のフォーマットに変換した最終更新日を受け取るための引数です。
 *
 */

const Post = ({ publishDate, publishDateJP, updatedAt, updatedAtJP }) => {
  return (
    <ul className={`${styles.post}`}>
      {(publishDate !== null || publishDateJP !== null) && (
        <li key={"post"}>
          投稿日 :{" "}
          <time itemProp="datePublished" dateTime={publishDate}>
            {publishDateJP}
          </time>
        </li>
      )}
      <li key={"lastUpdate"}>
        最終更新日 :{" "}
        <time itemProp="datePublished" dateTime={updatedAt}>
          {updatedAtJP}
        </time>
      </li>
    </ul>
  );
};

export default Post;
